import { axios, def, handleError, handleResponse } from './internal';

function AdminPostChangeStatus(postId, status, onSuccess) {
    axios
        .post('/api/admin_post_changestatus', { postId, status })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK:
                    onSuccess?.(res.data.data.post);
                    break;
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        });
}

export { AdminPostChangeStatus };
